jQuery(function($){
    var nav = $('.section-nav');
    if (!nav.length) return;
    nav.removeClass('section-nav');
    var sectionElems = nav.closest('.vc_section');
    sectionElems.addClass('section-nav');
    nav.find('ul').addClass('section-nav__menu menu');
    nav.find('li').addClass('section-nav__menu-item menu-item');
    nav.find('a').addClass('section-nav__menu-link menu-link');

    var row = nav.closest('.wpb_row');
    row.addClass('section-nav__body');
    var col = nav.closest('.wpb_column')
    col.addClass('section-nav__links');
    col.siblings().addClass('section-nav__content');
    var panels = col.siblings().find('.wpb_wrapper:first');
    panels.addClass('section-nav__panels');
    panels.children().addClass('section-nav__panel');

    $('.section-nav__menu').on('click', 'a', function(e){
        e.preventDefault();
        var containerElem = $(this).closest('.section-nav');
        // set active link
        $('.section-nav__menu-link', containerElem).removeClass('active');
        $(this).closest('.section-nav__menu-link').addClass('active');
        // set active panel
        $('.section-nav__panel', containerElem).removeClass('open')
        $($(this).attr('href'), containerElem).addClass('open');
    });

    panels.find('> :first-child').addClass('open');

    $('.section-nav__menu a:first').trigger('click');

    // remove class hidden if applied to prevent FOUC
    // @see https://en.wikipedia.org/wiki/Flash_of_unstyled_content
    sectionElems.removeClass('hidden');
});
